import { render } from "./App.vue?vue&type=template&id=f3ff645e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f3ff645e&lang=scss"
import "./App.vue?vue&type=style&index=1&id=f3ff645e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ff645e"]])

export default __exports__